export type MailBucket = "gmail" | "outlook" | "other";

export function mailBucketFromEmail(email: string | undefined): MailBucket {
  const host = String(email || "")
    .trim()
    .toLowerCase()
    .split("@")
    .pop() || "";
  if (
    host === "gmail.com" ||
    host === "googlemail.com" ||
    host.endsWith(".gmail.com")
  ) {
    return "gmail";
  }
  if (
    host === "outlook.com" ||
    host === "hotmail.com" ||
    host === "live.com" ||
    host === "msn.com" ||
    host.endsWith(".outlook.com") ||
    host.endsWith(".onmicrosoft.com") ||
    host.endsWith(".office365.com")
  ) {
    return "outlook";
  }
  return "other";
}

export function mailBucketLabel(bucket: MailBucket): string {
  if (bucket === "gmail") return "Google";
  if (bucket === "outlook") return "M365";
  return "Other";
}
